import React, { useEffect, useState } from 'react';
import ChannelsShareTable from '@op/pages/community/streaming/widgets/ChannelsShare/ChannelsShareTable';
import { getStreamingChannelShare } from '@op/services/community';
import { getRationPercentValue } from '@op/utils';
import { sortable } from 'tea-component/lib/table/addons';
import CardCommon from '@op/components/CardCommon';
import { getName } from '@home/utils/common';
import { getLocale } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';
import { useToOpinionPage } from '../../../utils';
import { changeChannel, getDefaultChannelList } from '@op/pages/community/constants';
import { addStudioChannel } from '../../../StudioTrendingVideo/utils';
import './index.scss';

/**
 * @param {string} metric - 用于展示的数据指标。
 * @param {any} filter - 用于筛选数据的过滤器对象。
 */
interface OpinionsStreamingChannleShareProps {
  metric?: string;
  filter: any;
  titleEn: string;
  titleCn: string;
  jumpUrl?: string;
  gameInfo: any;
}

export default function OpinionsStreamingChannleShare(props: OpinionsStreamingChannleShareProps) {
  const {
    metric = 'hoursWatched',
    filter,
    titleCn,
    titleEn,
    gameInfo
  } = props || {};
  const [sort, setSort] = useState<{ by: string; order: 'asc' | 'desc'; }>({
    by: 'value',
    order: 'desc',
  });
  const [total, setTotal] = useState(0);
  const [totalColumn, setTotalColumn] = useState({
    user_name: 'Total',
    value: 0,
    ration_percent: 0,
  });
  const [tableRecords, setTableRecords] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(false);

  const locale = getLocale();
  const isEN = locale === LANGUAGE_EN;

  const channelList = getDefaultChannelList(gameInfo.edition_unified_id);

  const { goToOtherPage } = useToOpinionPage({
    filter,
    key: 'Community Performance',
    subKey: 'streaming'
  });

  const clearRecords = () => {
    setTableRecords([]);
    setTotal(0);
  };

  /**
   * 获取服务器数据信息并处理
   * 
   * 如果筛选条件为空或者游戏信息中的 edition_unified_id 不存在，则不进行后续操作。
   * 处理返回的数据，计算比例百分比，排序，并更新表格记录和总计列。
   */
  const getServerDataInfo = () => {
    const { edition_unified_id, start_time, end_time } = filter || {};
    if (Object.keys(filter).length === 0 || !edition_unified_id || !start_time || !end_time) {
      return;
    }
    const { channels, ...other } = filter;
    const paramsInfo = {
      ...other,
      channels: addStudioChannel(changeChannel(channelList)),
      metric,
      source: 'channel',
      channel_type: "social"
    };
    setLoading(true);
    clearRecords();
    getStreamingChannelShare(paramsInfo)
      .then((data: any) => {
        const { list, total, total_old, total_new } = data;
        if (list && list.length > 0) {
          const newList = list
            ?.map((item: any) => ({
              ...item,
              ration_percent: getRationPercentValue(item.new, item.old),
              value: item.new,
            }))?.sort(sortable?.comparer([sort]));
          setTotalColumn({
            user_name: 'Total',
            value: total_new,
            ration_percent: getRationPercentValue(total_new, total_old),
          });
          // 只取前5
          setTableRecords(newList?.slice(0, 5));
        }
        setTotal(total || 0);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getServerDataInfo();
  }, [filter, metric]);

  return (
    <CardCommon
      className={'dbh-opinions-streaming-channle-share'}
      hasTitleArrow
      loading={false}
      loadingHeight={300}
      emptyHeight={300}
      title={getName(isEN, titleEn, titleCn)}
      handleTitleOnClick={goToOtherPage}
      hasDownload={false}
    >
      <ChannelsShareTable
        sort={sort}
        sortChange={setSort}
        total={total}
        metric={metric}
        totalColumn={totalColumn}
        tableList={tableRecords}
        defaultPageSize={10}
        loading={loading}
      ></ChannelsShareTable>
    </CardCommon>
  );
}
